import { createContext } from "react";

export const LevelContext = createContext({ level: 0, subLevel: 0 });
export const ScorableValidationContext = createContext<{
    showValidationErrors: boolean;
}>({ showValidationErrors: false });
export const PreviewModeContext = createContext({ previewMode: false });
export const RescoreModeContext = createContext({ rescoreMode: false });
export const CheckboxModeContext = createContext({
    checkboxMode: false,
});
export const UserModeContext = createContext({ isAdmin: false });
export const HasEditScoreOrEditPermissionsContext = createContext<{
    hasEditScoreOrEditPermissions?: boolean;
}>({ hasEditScoreOrEditPermissions: undefined });
export const HasAddFormPermissionsContext = createContext({
    hasAddFormPermissions: false,
});
